import { useState, useMemo } from 'react';
export function usePagination({
  data,
  itemsPerPage
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / itemsPerPage));

  // Make sure currentPage is within valid range when data length changes
  if (currentPage > totalPages) {
    setCurrentPage(totalPages);
  }

  // Calculate pagination
  const currentItems = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
  }, [data, currentPage, itemsPerPage]);

  // Navigation functions
  const goToPage = page => {
    const validPage = Math.max(1, Math.min(page, totalPages));
    setCurrentPage(validPage);
  };
  return {
    currentPage,
    totalPages,
    currentItems,
    goToPage
  };
}